import CompoundCoursePart from "@/models/CompoundCoursePart";
import CourseRun from "@/models/CourseRun";
import LiveCourseParticipant from "@/models/LiveCourseParticipant";
import BuyCourse from "@/models/BuyCourse";

export default class PublicBuyCourseDate {
    constructor(raw = {}) {
        this.dateId = raw.dateId;
        this.start = raw.start;
        this.end = raw.end;
        this.course = new BuyCourse(raw.course);
        this.online = raw.online;
        this.location = raw.location;
    }
}
